
import { computed, defineComponent, toRefs, reactive, PropType } from 'vue'
import { useI18n } from 'vue-i18n'
import { useReflectiveInjector } from '@tanbo/vue-di-plugin'
import {
  GroupPolicySettingsService,
  TaskTimeSetting
} from '@/views/dashboard/_components/group-policy-settings/group-policy-settings.service'
import { formatMinuteToTime } from '@/utils/format'
const TIME_STEP = 10
const MAX_NEXT_TIME = 1430
export default defineComponent({
  props: {
    idx: {
      type: Number,
      default: 0
    },
    mainSwitch: {
      type: Boolean,
      default: false
    },
    mixType: {
      type: Number,
      default: 1
    },
    sKey: {
      type: String,
      default: ''
    },
    item: {
      type: Object as PropType<TaskTimeSetting>,
      default: () => ({})
    }
  },
  setup (props) {
    const { t, locale } = useI18n()
    const injector = useReflectiveInjector([])
    const service = injector.get(GroupPolicySettingsService)

    const data = reactive({
      target: props.item.target || 1,
      start_min: formatMinuteToTime(props.item.start_min),
      end_min: formatMinuteToTime(props.item.end_min),
      selectorsValue: [] as TaskTimeSetting[]
    })
    function parseMinuteSelectTime (timeStr: any) {
      let parsedTime = 0
      const [hourTimeStr, minTimeStr] = timeStr.split(':')
      const hourTime = Number(hourTimeStr)
      const minTime = Number(minTimeStr)

      if (hourTime) {
        parsedTime = hourTime * 60
      }
      parsedTime = parsedTime + minTime
      return parsedTime
    }
    function fixEndTimeGreaterThanStartTime (start:number, end: number) {
      /** 使结束时间比开启时间大 */
      if (end <= start) {
        const nextTime = start + TIME_STEP
        if (nextTime >= MAX_NEXT_TIME - TIME_STEP) {
          end = MAX_NEXT_TIME
        } else {
          end = nextTime
        }
        data.end_min = formatMinuteToTime(end)
        data.selectorsValue[props.idx].end_min = end
      }
    }
    service[props.sKey].subscribe((stategy: any) => {
      data.selectorsValue = stategy
    })
    const WeekDayOptions = computed(() => {
      void locale.value
      return [
        { label: t('groupPolicySettings.schedWeekMon'), value: 1 },
        { label: t('groupPolicySettings.schedWeekTue'), value: 2 },
        { label: t('groupPolicySettings.schedWeekWed'), value: 3 },
        { label: t('groupPolicySettings.schedWeekThu'), value: 4 },
        { label: t('groupPolicySettings.schedWeekFri'), value: 5 },
        { label: t('groupPolicySettings.schedWeekSat'), value: 6 },
        { label: t('groupPolicySettings.schedWeekSun'), value: 7 },
      ]
    })
    return {
      ...toRefs(data),
      WeekDayOptions,
      updateTarget () {
        service.updateEditTab(true)
        data.selectorsValue[props.idx].target = data.target
        service.updateSelectors(props.sKey, data.selectorsValue)
      },
      updateStartTime () {
        service.updateEditTab(true)
        data.selectorsValue[props.idx].start_min = parseMinuteSelectTime(data.start_min)
        fixEndTimeGreaterThanStartTime(parseMinuteSelectTime(data.start_min), parseMinuteSelectTime(data.end_min))
        service.updateSelectors(props.sKey, data.selectorsValue)
      },
      updateEndTime () {
        service.updateEditTab(true)
        data.selectorsValue[props.idx].end_min = parseMinuteSelectTime(data.end_min)
      }
    }
  }
})
